import { ChartPalette } from '../../../../../../../styles/chart-palette';
import { PublishedOption } from '../types';
import Bar from './Bar';
import { barGraphClasses, Root } from './styles';

export interface BarGraphProps {
  publishedOptions: PublishedOption[];
  canSeeResults: boolean;
  className?: string;
}

const BarGraph = ({ publishedOptions, canSeeResults, className }: BarGraphProps) => {
  return (
    <Root className={className}>
      {publishedOptions.map((option, index) => (
        <Bar
          key={option.optionId}
          label={option.alphabet}
          value={option.selectionPercentage}
          color={ChartPalette[index]}
          optionText={option.text}
          canSeeResults={canSeeResults}
          className={barGraphClasses.bar}
        />
      ))}
    </Root>
  );
};

export default BarGraph;
